import { EndpointError } from '../client/response';

export function isConflictError(error: unknown): error is EndpointError {
  return error instanceof EndpointError && error.response.status === 409;
}
